import { IconButton, Tooltip } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import React from 'react';

const Acciones = ({ item, classes, onEdit, onDelete, onDeactivate }) => {
  return (
    <TableCell className={classes.tableCellAction}>
      <Tooltip title="Editar" aria-label="editar">
        <IconButton aria-label="editar" onClick={() => onEdit && onEdit(item)}>
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip
        title={item.activado ? 'Inactivar' : 'Activar'}
        aria-label="activar/desactivar"
      >
        <IconButton
          aria-label="delete"
          onClick={() => onDeactivate && onDeactivate(item)}
        >
          {item.activado ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </Tooltip>
      <Tooltip title="Eliminar" aria-label="eliminar">
        <IconButton
          aria-label="delete"
          onClick={() => onDelete && onDelete(item)}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </TableCell>
  );
};

const importadorConfig = ({
  classes,
  onView,
  onEdit,
  onDelete,
  onDeactivate,
  enqueueSnackbar
}) => {
  return {
    importador: {
      datosConfig: {
        titulo: 'Seleccione el importador',
        servicio: 'importador',
        url: 'importador'
      },
      datosSettings: {
        nombre: {
          label: 'Nombre',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>{item.nombre}</TableCell>
          )
        },
        direccion: {
          label: 'Dirección',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.direccion || ''}
            </TableCell>
          )
        },
        'pais.nombre': {
          label: 'País',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.nombrePais || ''}
            </TableCell>
          )
        },
        ciudad: {
          label: 'Ciudad',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.ciudad || ''}
            </TableCell>
          )
        },
        codigoPostal: {
          label: 'Código Postal',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.codigoPostal || ''}
            </TableCell>
          )
        },
        email: {
          label: 'Correo',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.email || ''}
            </TableCell>
          )
        }
      }
    },
    importadorList: {
      datosConfig: {
        titulo: 'Seleccione el importador',
        servicio: 'importador',
        url: 'importador'
      },
      datosSettings: {
        nombre: {
          label: 'Nombre',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>{item.nombre}</TableCell>
          )
        },
        direccion: {
          label: 'Dirección',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.direccion || ''}
            </TableCell>
          )
        },
        'pais.nombre': {
          label: 'País',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.nombrePais || ''}
            </TableCell>
          )
        },
        ciudad: {
          label: 'Ciudad',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.ciudad || ''}
            </TableCell>
          )
        },
        codigoPostal: {
          label: 'Código Postal',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.codigoPostal || ''}
            </TableCell>
          )
        },
        email: {
          label: 'Correo',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.email || ''}
            </TableCell>
          )
        },
        actions: {
          label: 'Acciones',
          sortable: false,
          cellRendering: item => (
            <Acciones
              item={item}
              classes={classes}
              enqueueSnackbar={enqueueSnackbar}
              onView={onView}
              onEdit={onEdit}
              onDelete={onDelete}
              onDeactivate={onDeactivate}
            />
          )
        }
      }
    }
  };
};

export default importadorConfig;
